<div [ngClass]="{teamMember:true, opened:member.expanded, withAvatar:!hideAvatar, partOfTheTeam: alreadyMember, isSchool: !member.isEvaluator, isEvaluator: member.isEvaluator}">
  <div [ngClass]="{clickableTitle:!hideFunctions && !alreadyMember && !member.isProgramManager}" (click)="expandToggle()">
    <div [ngClass]="{memberData:true, withAvatar:!hideAvatar}">
      <app-user-avatar
        [firstName]="member.member.firstName"
        [lastName]="member.member.lastName"
        [fullName]="member.member.name"
        [avatar]="member.member.profilePicture"
      ></app-user-avatar>
      <span [ngClass]="{wrappingName:!hideAvatar}">{{member.member.name}}</span>
    </div>
  </div>
  @if (!hideFunctions && !alreadyMember && !member.isProgramManager) {
    <button class="expander" (click)="expandToggle()">
      @if (member.expanded) {
        <i class="material-icons">expand_less</i>
      }
      @if (!member.expanded) {
        <i class="material-icons">expand_more</i>
      }
    </button>
  }
  @if (member.expanded && !hideFunctions && !isSearch && !alreadyMember && !member.isProgramManager) {
    <div class="memberFunctions">
      <div>
        <mat-radio-group aria-label="Select an option">
          <mat-radio-button
            value="1"
            matTooltip="{{editAccessTooltip}}"
            (change)="setUserAccess(true, true)"
            [checked]="member.individualAccess.allowEdit"
          >
            Edit access
          </mat-radio-button>
          @if (applicationType === appType.accreditation) {
          <mat-radio-button
            value="2"
            matTooltip="{{commentAccessTooltip}}"
            (change)="setUserAccess(false, true)"
            [checked]="!member.individualAccess.allowEdit && member.individualAccess.allowComment"
          >
            Comment access
          </mat-radio-button>
          }
          <mat-radio-button
            value="3"
            matTooltip="{{readAccessTooltip}}"
            (change)="setUserAccess(false, false)"
            [checked]="
              (applicationType === appType.accreditation && (!member.individualAccess.allowComment && !member.individualAccess.allowEdit)) ||
              (applicationType === appType.assessment && !member.individualAccess.allowEdit)"
          >
            Read access
          </mat-radio-button>
        </mat-radio-group>

      </div>
      <button class="button" (click)="deleteUser()">Remove User</button>
    </div>
  }


  @if (member.expanded && !hideFunctions && isSearch && !alreadyMember && !member.isProgramManager) {
    <div class="memberFunctions">
      <div>
        <div class="weaveFormField weaveFormFieldRadio">
          <div class="weaveRadioGroup">
            <mat-radio-group
              class="mat-radio-group-vertical"
              (change)="setNewUserAccess($event.value)"
            >
              <mat-radio-button
                matTooltip="{{editAccessTooltip}}"
                [value]="{'editAccess': true, 'commentAccess': true}"
                [checked]="editAccess"
              >Edit access</mat-radio-button>
              @if (applicationType === appType.accreditation) {
                <mat-radio-button
                  matTooltip="{{commentAccessTooltip}}"
                  [value]="{'editAccess': false, 'commentAccess': true}"
                  [checked]="!editAccess && commentAccess"
                >Comment access</mat-radio-button>
              }
              <mat-radio-button
                matTooltip="{{readAccessTooltip}}"
                [value]="{'editAccess': false, 'commentAccess': false}"
                [checked]="(!editAccess && !commentAccess) || (applicationType === appType.assessment && !editAccess)"
              >Read access</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <button class="button" (click)="addUser()">Add User</button>
    </div>
  }

  @if (alreadyMember) {
    <div>
      @if (member.individualAccess.allowEdit) {
        <div class="editAccessLabel accessLabel"><i class="accessIcon material-icons">edit</i> EDIT ACCESS</div>
      }
      @if (!member.individualAccess.allowEdit) {
        <div class="readAccessLabel accessLabel"><i class="accessIcon material-icons">visibility</i> READ ACCESS</div>
      }
    </div>
  }
</div>
